export default __webpack_public_path__ + "static/australian-thermic-lance-company-mobile-6e8964195b5e50ee166a98aa9f7b112c.gif";